export default __webpack_public_path__ + "5268a27c2333918900798308d9a812a2.png";